import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { initializeDatabase } from '../services/firebaseInit';
import '../styles/InitializePage.css';

export const InitializePage: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const handleInitialize = async () => {
    try {
      setLoading(true);
      setError(null);
      setSuccess(false);

      console.log('Starting initialization...');
      await initializeDatabase();
      console.log('Initialization complete!');

      setSuccess(true);
      setTimeout(() => {
        navigate('/dashboard');
      }, 2000);
    } catch (err: any) {
      const errorMsg = err?.message || err?.toString() || 'Failed to initialize database';
      console.error('Initialization error:', errorMsg, err);
      setError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="initialize-container">
      <div className="initialize-card">
        <div className="initialize-header">
          <h1>Initialize Database</h1>
          <p>Set up your Redmax Quoting System</p>
        </div>

        {error && (
          <div className="error-message">
            <strong>Error:</strong> {error}
          </div>
        )}

        {success && (
          <div className="success-message">
            <strong>Success!</strong> Your database has been initialized.
          </div>
        )}

        <div className="initialize-content">
          <h3>This will create:</h3>
          <ul>
            <li>✓ Material Categories (Wood, Acrylic, Plastic, Metal, Vinyl, Paper)</li>
            <li>✓ Default Materials in each category</li>
            <li>✓ Processes/Modifiers (CNC, Flatbed Print, Colex Print+Cut, Hand Finishing)</li>
            <li>✓ Labor Rates (General, Installation, Design)</li>
            <li>✓ Vinyl Types (White, Clear, Premium)</li>
            <li>✓ Company Settings & Branding defaults</li>
          </ul>

          <div className="initialize-info">
            <p><strong>Note:</strong> This will only run once. If you've already initialized, click Initialize again and it will skip existing data.</p>
          </div>
        </div>

        <button
          onClick={handleInitialize}
          className="initialize-button"
          disabled={loading || success}
        >
          {loading ? 'Initializing...' : success ? 'Done!' : 'Initialize Database'}
        </button>

        {success && (
          <p className="redirect-message">Redirecting to dashboard...</p>
        )}
      </div>
    </div>
  );
};
